import { I18n } from "aws-amplify/utils";
import { Typography } from "@mui/material";

export const alarmColumns = () => [
  {
    id: "name",
    label: I18n.get("Name"),
    align: "left",
    flex: 1,
    rendercell: (params) => (
      <Typography
        component="a"
        href={`https://eptarefrigeration.lightning.force.com/${params.row.contact_id}`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          fontSize: "medium",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {params.value}
      </Typography>
    ),
  },

  {
    id: "phone",
    label: I18n.get("Phone"),
    align: "left",
    flex: 1,
    rendercell: (params) => (
      <Typography
        component="a"
        href={`tel:${params.value}`}
        sx={{
          fontSize: "medium",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  {
    id: "mobile_phone",
    label: I18n.get("Mobile"),
    align: "left",
    flex: 1,
    rendercell: (params) => (
      <Typography
        component="a"
        href={`tel:${params.value}`}
        sx={{
          fontSize: "medium",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  {
    id: "email",
    label: I18n.get("Email"),
    align: "left",
    flex: 1,
    rendercell: (params) => (
      <Typography
        component="a"
        href={`mailto:${params.value}`}
        sx={{
          fontSize: "medium",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {params.value}
      </Typography>
    ),
  },
  {
    id: "fsl_priority",
    label: I18n.get("Priority"),
    align: "left",
    flex: 1,
  },
  {
    id: "fsl_contact_availability",
    label: I18n.get("Contact Availability"),
    align: "left",
    flex: 1,
  },
  {
    id: "fsl_contact_availability_notes",
    label: I18n.get("Contact Availability Notes"),
    align: "left",
    flex: 1,
  },
];
